// extracted by mini-css-extract-plugin
export default {"contentWrapper":"InformationSection_contentWrapper__DzqVb","titleWrapper":"InformationSection_titleWrapper__ikE9S","wrapper":"InformationSection_wrapper__DIS2A"};